import React from "react";
import Modal from "react-bootstrap/Modal";

const CustomModal = ({ isOpen, onRequestClose, title, children,taille="md" }) => {
  return (
    <Modal
      show={isOpen}
      onHide={onRequestClose}
      size={taille}
      aria-labelledby="contained-modal-title-center"
      centered
      scrollable={false}
      dialogClassName="custom-modal"
      className="bg-transparent"
      
    >
      <Modal.Header
        closeButton
        className="border-0 class-bg-br-S  boder-top-lr30"
      >
        <Modal.Title id="contained-modal-title-vcenter">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-0 m-0 border-0  class-bg-light boder-bottom-lr30 boder-top-lr30">
        {children}
      </Modal.Body>
    </Modal>
  );
};

export default CustomModal;
